<template>
  <div class="ViewSeoColumns">
    <h2 class="ViewSeoColumns__title app-main-title">
      {{ title }}
    </h2>
    <div class="ViewSeoColumns__row">
      <div class="ViewSeoColumns__col">
        <slot name="col1"></slot>
      </div>
      <div class="ViewSeoColumns__col">
        <slot name="col2"></slot>
      </div>
      <div class="ViewSeoColumns__col">
        <slot name="col3"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ViewSeoColumns',
  props: {
    title: {
      type: String,
      require: true,
    },
  },
};
</script>
<style lang="scss">
.ViewSeoColumns {
  &__row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-bottom: -15px;
    margin-left: -15px;
  }

  &__col {
    flex-grow: 1;
    width: calc(33.3333% - 30px);
    margin: 15px;

    h3 {
      margin-top: 0;
      font-size: 22px;
      font-weight: 700;
    }

    @include media-sm() {
      width: calc(100% - 30px);
    }
  }
}
</style>
